import {
	type AdminFeedbackFilters,
	type AdminUpdateFeedback,
	adminFeedbackSchema,
	type CreateFeedback,
	feedbackSchema,
	feedbackScreenshotResponseSchema,
} from "../schemas/feedback";
import { fetchApi, fetchFormData, paginatedSchema } from "./internal";

export const feedback = {
	submit: (body: CreateFeedback) =>
		fetchApi("/feedback", feedbackSchema, {
			method: "POST",
			body: JSON.stringify(body),
		}),
	uploadScreenshot: (file: File) => {
		const formData = new FormData();
		formData.append("screenshot", file);
		return fetchFormData("/feedback/screenshots", feedbackScreenshotResponseSchema, formData);
	},
	adminList: (filters?: AdminFeedbackFilters) => {
		const search = new URLSearchParams();
		if (filters?.status) search.set("status", filters.status);
		if (filters?.category) search.set("category", filters.category);
		if (filters?.source) search.set("source", filters.source);
		if (filters?.q) search.set("q", filters.q);
		if (filters?.limit !== undefined) search.set("limit", String(filters.limit));
		if (filters?.offset !== undefined) search.set("offset", String(filters.offset));
		const qs = search.toString();
		return fetchApi(`/admin/feedback${qs ? `?${qs}` : ""}`, paginatedSchema(adminFeedbackSchema));
	},
	adminGet: (id: string) => fetchApi(`/admin/feedback/${id}`, adminFeedbackSchema),
	adminUpdate: (id: string, body: AdminUpdateFeedback) =>
		fetchApi(`/admin/feedback/${id}`, adminFeedbackSchema, {
			method: "PATCH",
			body: JSON.stringify(body),
		}),
};
